import type { GuardBusy } from 'ts-components/PiChat/PiChatPanel';

export interface SaveThenOpenRequest {
  stepId?: string;
  confirm: () => boolean;
}

export interface CodeStepAiApi {
  canOpen: boolean;
  saveThenOpen: (request: SaveThenOpenRequest) => Promise<unknown>;
  saving: boolean;
  activeStepId: string | null;
}

export interface CodeStepSessionTarget {
  automationId: string;
  stepId: string;
}

/** Whether opening `stepId` in `automationId` keeps `current` rather than starting a new session. */
export const keepsCodeStepSession = (
  current: CodeStepSessionTarget | null,
  automationId: string | null,
  stepId: string | undefined
) =>
  current !== null &&
  current.stepId === stepId &&
  current.automationId === automationId;

/**
 * Opens `stepId` once its save has finished. Keeping the current session never asks; replacing it goes through
 * `guard`, so a chat that is busy at this moment gets the leave confirmation, and `open` runs only once confirmed.
 */
export const openCodeStepSession = (
  current: CodeStepSessionTarget | null,
  automationId: string,
  stepId: string,
  guard: GuardBusy,
  open: () => void
) => {
  if (keepsCodeStepSession(current, automationId, stepId)) open();
  else guard(open);
};

export const isPersistedStepId = (stepId: string | null | undefined) =>
  Boolean(stepId) && !stepId!.startsWith('new');
